import { useEffect, type ReactElement } from 'react';
import { Box, Table, Tbody, Td, Tr } from '@ff-it/ui';
import { CampaignWidget, CampaignWidgetProps, EntityFormActions } from 'components';
import useSWR from 'swr';
import { sepFormat } from 'utilities';
import { Card } from '@ff-it/ui';
import { verticalClamp } from './style.css';
import { unlinkAll } from '../actions';

type LinkedCampaignsProps = {
  endpoint: string;
  bound: string;
};

export function LinkedCampaigns({ endpoint, bound }: LinkedCampaignsProps): ReactElement {
  const { data, mutate } = useSWR<{ amount: string; campaign: CampaignWidgetProps }[], any, { suspense: true }>(
    { url: `${endpoint}campaigns/`, method: 'GET' },
    { suspense: true },
  );
  // biome-ignore lint/correctness/useExhaustiveDependencies: mutate is stable
  useEffect(() => {
    mutate();
  }, [bound]);

  return (
    <Card.Container testId="linked-campaigns" mb="3" width="full">
      <Card.Header>
        <Box display="flex" alignItems="center">
          Linked campaigns
          <Box ml="auto" my="-2">
            <EntityFormActions actions={[unlinkAll]} />
          </Box>
        </Box>
      </Card.Header>
      <Box className={verticalClamp}>
        <Table size="xs" fixed>
          <Tbody>
            {data.map(({ amount, campaign }) => (
              <Tr key={campaign.id}>
                <Td>
                  <CampaignWidget {...campaign} link />
                </Td>
                <Td textAlign="right" style={{ width: '90px' }}>
                  {sepFormat(amount)}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Card.Container>
  );
}
